import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('SalesOrganization?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('SalesOrganization/show/'+id);
    },    
    create(params) {
        return Service().post('SalesOrganization/create', params);
    },
    update(id, params) {
        return Service().post('SalesOrganization/update/'+id, params);
    },
    delete(id) {
        return Service().post('SalesOrganization/delete/'+id);
    }
}